import { c as _c } from "react/compiler-runtime";
import { ServiceFeaturedCard } from '../service-featured-card';
import { ServiceMarketplaceCard } from '../service-marketplace-card';
import type { EnrichedService } from '../../types';
interface ServicesFeaturedSectionProps {
  services: EnrichedService[];
}
function ServicesFeaturedSection(t0) {
  const $ = _c(5);
  const {
    services
  } = t0;
  if (services.length === 0) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <h2 className="text-foreground text-xl leading-tight font-bold">Featured</h2>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== services) {
    t2 = services.map(_temp);
    $[1] = services;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <section className="flex flex-col gap-4">{t1}<div className="grid grid-cols-1 gap-4 sm:grid-cols-3 sm:gap-6">{t2}</div></section>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}
function _temp(enrichedService, index) {
  return index === 0 ? <ServiceFeaturedCard key={enrichedService.service.id} enrichedService={enrichedService} primary={true} /> : <ServiceMarketplaceCard key={enrichedService.service.id} enrichedService={enrichedService} />;
}
export { ServicesFeaturedSection };